
/**
 * Crée un DOM element a partir d'un array d'object
 * @param {object} data
 */
export function createAllBlock(data){

    let html = '';
    $.each(data, function(index, object){
        
        // verifie le type de chaque element et crée le block html correspondant
        if(object.type === 'twitter'){
            html += createtwitterBlock(object);
        }

        if(object.type === 'facebook'){
            html += createFacebookBlock(object);
        }

        if(object.type === 'instagram'){
            html += createInstagramBlock(object);
        }

        if(object.type === 'youtube'){
            html += createYoutubeBlock(object);
        }

    });

    return $(html);
}

/** Crée le block facebook */
function createFacebookBlock(post)
{   
    let html = `<div class="socialWall-item socialWall-facebook">
                    <a href="${post.url}" target="_blank">
                        <div class="socialWall-contenu">
                            <div class="socialWall-header">
                                <i class="fa fa-facebook"></i>
                                <div>
                                    <span class="tag">@${post.pageName}</span>
                                    <div class="socialWall-date">${post.date}</div>
                                </div>
                            </div>
                            <p>
                                ${post.description}
                            </p>
                        </div>
                    </a>
                </div>`
    return html;
}

/** Crée le block Instagram */
/**
 * <pre>${post.text.slice(0, 450)}</pre>
 */
function createInstagramBlock(post)
{   let html = `<div class="socialWall-item socialWall-instagram">
                    <a href="${post.url}" target="_blank">
                        <i class="fa fa-instagram"></i>
                        ${post.img ?
                            `<figure style="background-image: url('${post.img}');"></figure>` : ''
                        }
                    </a>
                </div>`
    return html;
}

/** Crée le block de Twitter */
function createtwitterBlock(post)
{

let html =  `<div class="socialWall-item socialWall-twitter">
                <a href="${post.url}" target="_blank">
                    <div class="socialWall-contenu">
                        <div class="socialWall-header">
                            <i class="fa fa-twitter"></i>
                            <div>
                                <span class="tag">@${post.screenName}</span>
                                <div class="socialWall-date">${post.date}</div>
                            </div>
                        </div>
                        <p>${post.message.replace(/<[^>]*>/g, '')} </p>
                    </div>
                </a>
            </div>`
    return html;
}

export function createYoutubeBlock(post)
{
    let html =`<div class="socialWall-item socialWall-youtube">
                    <div class="blocYoutube">
                        <iframe width="100%" height="315" src="${post.url}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>`;
    return html;
}


export function createFacebookHomeBlock(post) {
    let html = `<div class="socialWall-item socialWall-facebook">
                    <a href="${post.url}" target="_blank">
                        <div class="socialWall-contenu">
                            <div class="socialWall-header">
                                <i class="fa fa-facebook"></i>
                                <div>
                                    <span class="tag">@${post.pageName}</span>
                                    <div class="socialWall-date">${post.date}</div>
                                </div>
                            </div>
                            <p>
                                ${post.description}
                            </p>
                        </div>
                    </a>
                </div>`
    return html;
}

export function createInstagramHomeBlock(post, classnb) {
    let html = `<div class="socialWall-item socialWall-instagram instagram${classnb}">
                    <a href="${post.url}" target="_blank">
                        <i class="fa fa-instagram"></i>
                        ${post.img ?
                            `<figure style="background-image: url('${post.img}');"></figure>` : ''
                        }
                    </a>
                </div>`
    return html;
}

export function createYoutubeHomeBlock(post) {
    let html =`<div class="socialWall-item socialWall-youtube">
                    <div class="blocYoutube">
                        <iframe width="100%" height="315" 
                            src="${post.url}" 
                            frameborder="0"
                            title="${post.titre}" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowfullscreen></iframe>
                    </div>
                </div>`;
    return html;
}

export function createtwitterHomeBlock(post) {
    let html =  `<div class="socialWall-item socialWall-twitter">
                <a href="${post.url}" target="_blank">
                    <div class="socialWall-contenu">
                        <div class="socialWall-header">
                            <i class="fa fa-twitter"></i>
                            <div>
                                <span class="tag">@${post.screenName}</span>
                                <div class="socialWall-date">${post.date}</div>
                            </div>
                        </div>
                        <p>${post.message.replace(/<[^>]*>/g, '')} </p>
                    </div>
                </a>
            </div>`
    return html;
}

/** Masque le loader du DOM */
export function switchLoading()
{
    $("#chargerPlusBlock").show();
    $("#chargement").removeClass('active');
}

/**
 * @param string text
 * @return string
 */
export function erreurBlock(text)
{
    return `<div class="alert alert-warning" role="alert">
                ${text}
            </div>`
}

/**
 * @param string text
 * @return string
 */
export function erreurBlockContainer(text)
{
    return `<div class="container alert alert-warning" role="alert">
                ${text}
            </div>`
}